module.exports = __webpack_public_path__ + "static/media/no_trumps.13628430.svg";